import { useEffect, useState } from 'react';
import { Seo } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Markdown } from '../components/Markdown';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Datenschutz() {
  const [cms, setCms] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/pages/datenschutz`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setCms)
      .catch(() => {});
  }, []);

  if (cms?.content) {
    return (
      <>
        <Seo
          title={cms.seo_title || 'Datenschutz | Felix Genuss'}
          description={cms.meta_description || 'Datenschutzerklärung von Felix Genuss.'}
          path="/datenschutz"
        />
        <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Datenschutz' }]} />
        <div className="container-site max-w-3xl pt-10" data-testid="datenschutz-cms">
          <h1 className="font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">{cms.title}</h1>
          <div className="mt-8">
            <Markdown>{cms.content}</Markdown>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Seo title="Datenschutz | Felix Genuss" description="Datenschutzerklärung von Felix Genuss: welche Daten wir verarbeiten, warum – und was wir bewusst nicht tun." path="/datenschutz" />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Datenschutz' }]} />
      <div className="container-site max-w-3xl pt-10">
        <h1 className="font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">Datenschutz</h1>
        <p className="mt-6 leading-relaxed text-brand-brown/85">
          Der Schutz deiner Daten ist uns wichtig. Diese Seite beschreibt transparent, welche Daten auf dieser Website verarbeitet werden. Die rechtsverbindliche Datenschutzerklärung wird vor der Produktionsfreigabe mit einer rechtlichen Fachperson finalisiert.
        </p>

        <section className="mt-10" aria-labelledby="ds-grundsaetze">
          <h2 id="ds-grundsaetze" className="font-serif text-2xl font-bold sm:text-3xl">Unsere Grundsätze</h2>
          <ul className="mt-4 list-disc space-y-2 pl-6 leading-relaxed text-brand-brown/90 marker:text-brand-gold">
            <li>Keine Tracking- oder Marketing-Cookies auf dieser Website.</li>
            <li>Keine externen Schriftarten – alle Fonts werden lokal bereitgestellt.</li>
            <li>Keine eingebetteten Drittanbieter-Inhalte wie Videos oder Social-Media-Widgets.</li>
            <li>Es werden nur die Daten verarbeitet, die für den jeweiligen Zweck erforderlich sind.</li>
          </ul>
        </section>

        <section className="mt-10" aria-labelledby="ds-formulare">
          <h2 id="ds-formulare" className="font-serif text-2xl font-bold sm:text-3xl">Kontaktformular und Newsletter</h2>
          <p className="mt-4 leading-relaxed text-brand-brown/85">
            Wenn du uns über das Kontaktformular schreibst, verarbeiten wir deinen Namen, deine E-Mail-Adresse und deine Nachricht ausschliesslich zur Beantwortung deiner Anfrage. Bei der Newsletter-Anmeldung speichern wir deine E-Mail-Adresse, um dir neue Rezepte und Beiträge zuzusenden. Eine Weitergabe an Dritte erfolgt nicht.
          </p>
        </section>

        <section className="mt-10" aria-labelledby="ds-rechte">
          <h2 id="ds-rechte" className="font-serif text-2xl font-bold sm:text-3xl">Deine Rechte</h2>
          <p className="mt-4 leading-relaxed text-brand-brown/85">
            Du hast jederzeit das Recht auf Auskunft, Berichtigung und Löschung deiner gespeicherten Daten. Wende dich dazu einfach über unser Kontaktformular an uns.
          </p>
        </section>

        <div className="mt-12 border-l-2 border-brand-gold bg-brand-beige p-6" data-testid="datenschutz-hinweis">
          <h2 className="font-serif text-xl font-bold">Für Produktionsfreigabe erforderlich</h2>
          <p className="mt-3 text-sm leading-relaxed text-brand-brown">
            Vor der Veröffentlichung werden ergänzt: die vollständigen Angaben zur verantwortlichen Stelle (siehe Impressum), Hosting-Details sowie – falls später eingesetzt – Angaben zu Newsletter-Anbieter, Analytics und Consent-Management.
          </p>
        </div>
      </div>
    </>
  );
}
